<div class="upload-media-wrapper">
  <div class="media_wrapper" [class.width_half]="showRequirements && defaultRequirements.length" [class.width_full]="!showRequirements || !defaultRequirements.length">
    <!-- Upload image - Drag & Drop area -->
    <div *ngIf="!imagePreview" 
         #uploadContainerRef 
         class="upload-container" 
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)" 
         (drop)="onDropSuccess($event)">
      <ng-container *ngIf="!isImageLoading">
        <img src="/assets/uploader-logos/uploadIconGreen.png" width="70px" />
        <p>Drag & Drop or <span (click)="chooseFile()" class="upload-link">Select From Computer</span></p>
      </ng-container>
      <p-progressSpinner *ngIf="isImageLoading" 
                        styleClass="w-2rem h-2rem" 
                        strokeWidth="2" 
                        fill="var(--surface-ground)"
                        [animationDuration]="spinnerAnimationDuration">
      </p-progressSpinner>
    </div>

    <!-- Image Preview -->
    <div *ngIf="imagePreview && imageValidationErrors.length === 0 && !isImageLoading" class="upload-container">
      <i class="pi pi-times-circle close" (click)="clearImage()"></i>
      <img [src]="imagePreview" height="300px" />
    </div>

    <!-- Hidden file input -->
    <input 
      type="file" 
      #fileInput
      [accept]="acceptAttribute"
      (change)="onInputChanged($event)" 
      style="display: none;"
    />

    <!-- Error Messages -->
    <ng-container *ngIf="imageValidationErrors.length > 0">
      <div class="error_msg">{{ imageValidationErrors[0] }}</div>
    </ng-container>
  </div>

  <!-- Photo Requirements Info -->
  <div *ngIf="showRequirements && defaultRequirements.length" class="requirements_wrapper">
    <b class="requirements_wrapper_title" *ngIf="requirementsTitle">{{ requirementsTitle }}</b>
    <ul>
      <li *ngFor="let requirement of defaultRequirements">{{ requirement }}</li>
    </ul>
  </div>
</div>
